<script setup>
   import { onMounted, ref, watchEffect, inject, computed } from 'vue'
   import { useRouter } from 'vue-router'
   import Logo from '@/components/Branding/CodeGinnelLogo.vue'
   import FeedbackForm from '@/components/Forms/FeedbackForm.vue'
   import Search from '@/components/Content/Search.vue'
   import { modalHide, modalShow, modalShowing } from '@/composables/bootstrap'
   import { generateID } from '@/composables/strings'

   const router = useRouter()

   const $storeUser = inject('$storeUser')
   const $storeAuth = inject('$storeAuth')
   const $storeGinnels = inject('$storeGinnels')

   onMounted(() => openModalWithKey())

   watchEffect(() => {
      if($storeAuth.isAuthenticated) {
         $storeUser.getUser()
      }
   })

   const openModalWithKey = () => {
      document.addEventListener('keydown', function(event) {
         if (event.metaKey && event.key === 'k') {
            if(modalShowing('search')) {
               modalHide('search')
            } else {
               callModal('search')
            }
         }
      })
   }

   const logout = () => $storeAuth.logout()

   const user = ref([])
   watchEffect(() => user.value = $storeUser.user)

   const checkVisibility = visibility => user.value?.preferences?.visibilities.includes(visibility) ? true : false

   const goto = routeName => router.push({ name: routeName })


   /**
      * Function: callModal
      * @description This function is used to call the modals
      *
      * @param {String} modalID - The ID of the modal
   */
   const searchOpened = ref('')
   const modalAction = ref('')
   const callModal = modalID => {
      modalAction.value = modalID
      searchOpened.value = `${modalID}-${generateID(5)}`
      setTimeout(() => modalShow(modalID), 50)
   }
</script>

<template>
   <div class="cg-navbar">
      <div class="logo">
         <RouterLink :to="{ name: 'home' }"><Logo size="160" /></RouterLink>
      </div>

      <div class="cg-row-content">
         <div v-if="user?.first_name" class="text-muted cg-row-content gap-3">
            <div @click="callModal('search')" role="button" class="cg-row-content gap-3">
               <span class="button-keys d-none d-sm-flex">
                  <kbd class="button-key">⌘</kbd>
                  <kbd class="button-key">K</kbd>
               </span>
               <FontAwesomeIcon icon="fa-solid fa-search" />
            </div>
            <span class="d-none d-sm-block">Welcome, {{ user.first_name }}!</span>
         </div>

         <div class="dropdown settings-menu">
            <div class="dropdown-toggle" data-bs-toggle="dropdown" role="button">
               <ProfilePhoto :user="user" size="35" :use-gravatar="checkVisibility('gravatar')" />
            </div>
            <ul class="dropdown-menu">

               <li @click="goto('account')">
                  <div class="dropdown-item">
                     <div class="body-text-icon"><FontAwesomeIcon icon="fa-solid fa-lock" /></div>
                     Account
                  </div>
               </li>

               <li @click="callModal('feedback')">
                  <div class="dropdown-item">
                     <div class="body-text-icon"><FontAwesomeIcon icon="fa-solid fa-comment-alt" /></div>
                     Feedback
                  </div>
               </li>

               <li><hr class="dropdown-divider"></li>

               <li @click="logout()">
                  <div class="dropdown-item">
                     <div class="body-text-icon"><FontAwesomeIcon icon="fa-solid fa-right-from-bracket" /></div>
                     Logout
                  </div>
               </li>

            </ul>
         </div>
      </div>
   </div>

   <Search :action="modalAction" :searchOpened="searchOpened" />
   <FeedbackForm :action="modalAction" />
</template>